import { render, staticRenderFns } from "./MedicinePrescription.vue?vue&type=template&id=4ee765e6&scoped=true&"
import script from "./MedicinePrescription.vue?vue&type=script&lang=js&"
export * from "./MedicinePrescription.vue?vue&type=script&lang=js&"
import style0 from "./MedicinePrescription.vue?vue&type=style&index=0&id=4ee765e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee765e6",
  null
  
)

export default component.exports